import React from "react";

const NotFound=()=> {
  return(
    <li className="not-found">
        <h3>No Results Found</h3>
        <p>The URL you are trying to access is invalid. Please try again or go to the homepage</p>
    </li>
  );
}

export default NotFound;